import React from "react";
import Homepage from "./components/homepage";
import ChatWidget from "./components/ChatWidget"; 

export default function App(){
  return(
    <>
    <Homepage/>
    <ChatWidget/> 
    </>
  );
}

